module.exports = __webpack_public_path__ + "static/media/instagramfeed.2f7c6a08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/instagramfeed.svg
// module id = 1065
// module chunks = 0